import React from "react";
import { CheckCircle2, Clock, Lock } from "lucide-react";

export function AvailableBadge({ status }) {
  if (status === "available")
    return (
      <span
        data-testid="badge-available"
        className="inline-flex items-center gap-2 rounded-full bg-black px-3 py-1 text-xs font-bold uppercase tracking-wider text-white"
      >
        <span className="live-dot" /> Available Now
      </span>
    );
  if (status === "coming_soon")
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-500 px-3 py-1 text-xs font-bold uppercase tracking-wider text-black">
        <Clock className="h-3.5 w-3.5" /> Coming Soon
      </span>
    );
  if (status === "rented")
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-zinc-200 px-3 py-1 text-xs font-bold uppercase tracking-wider text-zinc-700">
        <Lock className="h-3.5 w-3.5" /> Currently Rented
      </span>
    );
  return null;
}

export function PhvBadge({ status }) {
  const licensed = status === "Manchester PHV Licensed";
  return (
    <span
      data-testid="badge-phv"
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider ${
        licensed
          ? "bg-[#00E676] text-black"
          : "border border-zinc-300 bg-white text-zinc-700"
      }`}
    >
      {licensed && <CheckCircle2 className="h-3.5 w-3.5" />}
      {status}
    </span>
  );
}
